/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MappedInitiativeRefDto
 */
export interface MappedInitiativeRefDto {
    /**
     * 
     * @type {string}
     * @memberof MappedInitiativeRefDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof MappedInitiativeRefDto
     */
    initiativeName?: string;
    /**
     * 
     * @type {number}
     * @memberof MappedInitiativeRefDto
     */
    strategicWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof MappedInitiativeRefDto
     */
    compositeOperational?: number;
}

/**
 * Check if a given object implements the MappedInitiativeRefDto interface.
 */
export function instanceOfMappedInitiativeRefDto(value: object): value is MappedInitiativeRefDto {
    return true;
}

export function MappedInitiativeRefDtoFromJSON(json: any): MappedInitiativeRefDto {
    return MappedInitiativeRefDtoFromJSONTyped(json, false);
}

export function MappedInitiativeRefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MappedInitiativeRefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'strategicWeight': json['strategicWeight'] == null ? undefined : json['strategicWeight'],
        'compositeOperational': json['compositeOperational'] == null ? undefined : json['compositeOperational'],
    };
}

export function MappedInitiativeRefDtoToJSON(json: any): MappedInitiativeRefDto {
    return MappedInitiativeRefDtoToJSONTyped(json, false);
}

export function MappedInitiativeRefDtoToJSONTyped(value?: MappedInitiativeRefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'strategicWeight': value['strategicWeight'],
        'compositeOperational': value['compositeOperational'],
    };
}

